

import * as React from "react";
import {
  Text,
  TextInput,
  View,
  StyleSheet,
  Image,
  TouchableWithoutFeedback,
  TouchableOpacity,
} from "react-native";

import { useNavigation } from "@react-navigation/native";
import { modifyPartner } from "../../redux/actions/PartnerActions";
import GlobalStyles from "../../components/GlobalStyles";
import axios from "axios";
import { useSelector } from "react-redux";
import { user_unset_firstrun, user_force_refresh } from "../../redux/actions/UserActions";
import { Auth } from "aws-amplify";
import getEnvVars from "../../enviroment";

const apiURL = getEnvVars().apiUrl;

var axi = axios.create({
  baseURL: apiURL,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

export default function FirstSignInFinishSignup({ route }) {
  const navigation = useNavigation();
  const sparkle = require("../../assets/res/sparkle.png");
  
        const userAttributes = useSelector((state) => state.user.user.attributes); 

        const epoch = new Date().getTime();
        const refId = Math.floor(epoch / 10);
        // const incRefId = userAttributes['custom:refererId'] || "";
        const incRefId = route.params.reffererId;
        const gName = route.params.gName;
        const fName = route.params.fName;
        var uPhone = route.params.uPhone;
        var uEmail = route.params.uEmail;
        const userobj = {
          memberId: userAttributes.sub,
          referFriendId: refId.toString(),
          refererId: incRefId,
          givenName: gName,
          familyName: fName,
          phone: uPhone,
          email: uEmail,
        }
        var cognitoUpdate = {
          "custom:auraNumber": userAttributes.sub
        }
        if(incRefId != '') {
          cognitoUpdate["custom:refererId"] = incRefId;
        }
        // console.log(userobj);
        axi.post("/createMember", userobj);
        user_unset_firstrun();

        React.useEffect(() => {
            async function updateUserAttr() {
                const u = await Auth.currentAuthenticatedUser();
                const r = await Auth.updateUserAttributes(u, cognitoUpdate);
              //  setTimeout(user_force_refresh(), 1000);
            }
            updateUserAttr();
            user_force_refresh();
            navigation.navigate("MainMenu");
        }, []);

  return (
    <View style={GlobalStyles.containerMB}>
      <View style={styles.modalContainerF}>
        <View style={styles.modalContainer}>
          <View>
            <View style={GlobalStyles.headerTextP}>
              <View style={GlobalStyles.headingStyle}>
                <Text style={styles.textStyleHeader}>Welcome!</Text>
                <Text>Would you care to give us a little more information</Text>
                <View style={styles.formStyle}>
          <View style={styles.hiddenInputContainer}>
            </View>
            </View>
              </View>
            </View>
          </View>
        </View>
        <Image style={styles.sparkle} source={sparkle} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  modalContainer: {
    height: 160,
    backgroundColor: "#FFC72C",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 60,
    borderTopLeftRadius: 60,
    borderTopRightRadius: 60,
    marginLeft: 15,
    marginRight: 15,
    paddingTop: 30,
  },
  modalContainerF: {
    marginTop: 150,
    paddingTop: 20,
    marginLeft: 15,
    marginRight: 15,
  },
  SubmitButtonStyle: {
    paddingTop: 10,
    backgroundColor: "#FFFF",
    borderRadius: 30,
    marginTop: 20,
    marginLeft: -15,
  },

  textStyleHeader: {
    color: "#fff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 16,
    marginLeft: -15,
  },

  textStyle: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 16,
    marginBottom: 10,
  },
  sparkle: {
    position: "absolute",
    top: 0,
    right: 0,
  },
});
